export default __webpack_public_path__ + "static/media/personality-refresh-blue.4887c09a.svg";